import React from "react";
import styles from '../../assets/styles/Admin.module.css';
import UploadImg from "./UploadImg";
import { TextField, Box, CircularProgress, Select, MenuItem, InputLabel, FormControl } from "@mui/material";


const styleInput = {
    width: { xs: '90%', md: '80%' },
    marginBottom: 3,
    fontSize: '13px !important',
    // Estilo cuando está enfocado
    '& label.Mui-focused': {
    color: '#343e47',
    },
    '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
        borderColor: '#343e47',
    },
    }
}


export default function Admin ({
    spiner, error, url, handleUpload, 
    handleImageChange, valueSelect, handleSelectChange, 
    handleTitleChange, handleSDescChange, handleLDescChange,
    handleSubmit, handleSelectCategoria, valueCategoria,
    handleFileChange, handleSubmitPdf, pdfEs, pdfEn, pdfDe,
    handlePrecioChange, cantegoriasList,
    title, sDesc, lDesc, precio,
    handleSoftDelete
}) {
  console.log("ADMIN COMPONENT PROPS:", { spiner, error, url, valueSelect, valueCategoria, title, sDesc, lDesc, precio, pdfEs, pdfEn, pdfDe, handleSoftDelete });

    return (
        <div className={styles.all}>
            <h1 className={styles.h1}>Añadir Destino</h1>
            <h3 className={styles.h3}>Subir Imagen</h3>
            <UploadImg url={url} handleUpload={handleUpload} handleImageChange={handleImageChange} texto="Subir"/>
            <h3 className={styles.h3}>Subir PDF</h3>
            <UploadImg pdf={pdfEs} handleUpload={handleSubmitPdf} handleImageChange={handleFileChange} texto="Español"/>
            <UploadImg pdf={pdfEn} handleUpload={handleSubmitPdf} handleImageChange={handleFileChange} texto="Ingles"/>
            <UploadImg pdf={pdfDe} handleUpload={handleSubmitPdf} handleImageChange={handleFileChange} texto="Alemàn"/>
            <form className={styles.form}>
                <h3 className={styles.h3}>Titulo</h3>
                <TextField
                    label='Español'
                    type='text'
                    name="titleEs"
                    sx={styleInput}
                    value={title?.titleEs || ''}
                    onChange={handleTitleChange}
                    required
                    focused
                />
                <TextField
                    label='Ingles'
                    type='text'
                    name="titleEn"
                    sx={styleInput}
                    value={title?.titleEn || ''}
                    onChange={handleTitleChange}
                    required
                    focused
                />
                <TextField
                    label='Alemán'
                    type='text'
                    name="titleDe"
                    sx={styleInput}
                    value={title?.titleDe || ''}
                    onChange={handleTitleChange}
                    required
                    focused
                />
                <h3 className={styles.h3}>Descripción Corta</h3>
                <TextField
                    label='Español'
                    type='text'
                    name="sDescEs"
                    sx={styleInput}
                    value={sDesc?.sDescEs || ''}
                    onChange={handleSDescChange}
                    required
                    focused
                />
                <TextField
                    label='Ingles'
                    type='text'
                    name="sDescEn"
                    sx={styleInput}
                    value={sDesc?.sDescEn || ''}
                    onChange={handleSDescChange}
                    required
                    focused
                />
                <TextField
                    label='Alemán'
                    type='text'
                    name="sDescDe"
                    sx={styleInput}
                    value={sDesc?.sDescDe || ''}
                    onChange={handleSDescChange}
                    required
                    focused
                />
                <h3 className={styles.h3}>Descripción Larga</h3>
                <TextField
                    label='Español'
                    type='text'
                    name="lDescEs"
                    sx={styleInput}
                    value={lDesc?.lDescEs || ''}
                    onChange={handleLDescChange}
                    required
                    focused
                />
                <TextField
                    label='Ingles'
                    type='text'
                    name="lDescEn"
                    sx={styleInput}
                    value={lDesc?.lDescEn || ''}
                    onChange={handleLDescChange}
                    required
                    focused
                />
                <TextField
                    label='Alemán'
                    type='text'
                    name="lDescDe"
                    sx={styleInput}
                    value={lDesc?.lDescDe || ''}
                    onChange={handleLDescChange}
                    required
                    focused
                />
                <h3 className={styles.h3}>Sección</h3>
                <FormControl fullWidth sx={styleInput}>
                    <InputLabel id="select-label-seccion">Select</InputLabel>
                    <Select
                        labelId="select-label-seccion"
                        id="select-seccion"
                        value={valueSelect}
                        label="Sección"
                        className={styles.input}
                        onChange={({target}) => {handleSelectChange(target.value)}}
                    >
                        <MenuItem value="sierraEc">SierraEc</MenuItem>
                        <MenuItem value="sierraPlus">SierraPlus</MenuItem>
                    </Select>
                </FormControl>
                <h3 className={styles.h3}>Categoría</h3>
                <FormControl fullWidth sx={styleInput}>
                    <InputLabel id="select-label-categoria">Select</InputLabel>
                    <Select
                        labelId="select-label-categoria"
                        id="select-categoria"
                        value={valueCategoria}
                        label="Categoría"
                        className={styles.input}
                        onChange={({target}) => {handleSelectCategoria(target.value)}}
                    >
                        {cantegoriasList.map((cat, index) => <MenuItem key={index} value={cat}>{cat}</MenuItem>)}
                    </Select>
                </FormControl>
                <h3 className={styles.h3}>Precio</h3>
                <TextField
                    label='Precio'
                    type='text'
                    name="precio"
                    sx={styleInput}
                    value={precio || ''}
                    onChange={handlePrecioChange}
                    required
                    focused
                />
                <button type="submit" className={styles.botonLogin} onClick={handleSubmit}>
                    {spiner ? 
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                            <CircularProgress sx={{color: '#eadf21', width: '20px !important', height: '20px !important'}}/>
                        </Box>
                        :
                        "Enviar"
                    }
                </button>
                {handleSoftDelete && (
                    <button
                        type="button"
                        className={styles.botonLogin}
                        style={{ marginTop: '10px', backgroundColor: '#b3261e' }}
                        onClick={handleSoftDelete}
                    >
                        Eliminar
                    </button>
                )}
                <p className={styles.error}>{error && "Error al enviar la solicitud"}</p>
            </form>
        </div>
    )
}